import { env, getClerkPublishableKey } from './env.schema'
import { authConfig } from './auth.config'

// Validate configuration early
getClerkPublishableKey()

/**
 * Configuration for Clerk authentication
 * Routes are driven by authConfig to keep onboarding flow in sync.
 */
export const clerkConfig = {
  /**
   * The publishable key from Clerk dashboard
   */
  publishableKey: env.VITE_CLERK_PUBLISHABLE_KEY ?? '',

  /**
   * Routes to redirect to for auth actions
   */
  routes: {
    /**
     * Where to redirect after sign in
     */
    afterSignIn: authConfig.clerk.afterSignIn,

    /**
     * Where to redirect after sign up
     */
    afterSignUp: authConfig.clerk.afterSignUp,

    /**
     * Where to redirect after sign out
     */
    afterSignOut: '/sign-in',

    /**
     * The sign in page
     */
    signIn: '/sign-in',

    /**
     * The sign up page
     */
    signUp: '/sign-up',
  },
}
